import { createContext, useContext } from 'react'
import type { To } from 'react-router-dom'

export interface SsrRoutingContextValue {
  statusCode?: number
  url?: string
}

export const SsrRoutingContext = createContext<SsrRoutingContextValue | undefined>(undefined)
export const SsrRoutingContextProvider = SsrRoutingContext.Provider

export function useSsrRoutingContext() {
  return useContext(SsrRoutingContext)
}

export function stringifyTo(to: To): string {
  if (typeof to === 'string') return to

  return [
    to.pathname ?? '',
    to.search ?? '',
    to.hash ?? '',
  ].join('')
}
